var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { showApplicationLoader, hideApplicationLoader, } from 'common/ApplicationLoader';
import { getCWMemberRecordsService } from 'services/CWMemberRecordsService/cWMemberRecords.service';
import { GET_ACCOUNT_PAGE_LIST, showError } from 'store/commonReducer/common.action';
export var GET_SENIOR_LIST_ADMIN_LIST = 'GET_SENIOR_LIST_ADMIN_LIST';
export var GET_SENIOR_LIST_ADMIN_LIST_SUCCESS = 'GET_SENIOR_LIST_ADMIN_LIST_SUCCESS';
export var GET_SENIOR_LIST_ADMIN_LIST_FAIL = 'GET_SENIOR_LIST_ADMIN_LIST_FAIL';
export var UPDATE_SENIOR_LIST_ADMIN_LIST_PAGE_NUMBER = 'UPDATE_SENIOR_LIST_ADMIN_LIST_PAGE_NUMBER';
export var RESET_SENIOR_LIST_ADMIN_LIST = 'RESET_SENIOR_LIST_ADMIN_LIST';
export var GET_SENIOR_LIST_ADMIN_SEARCH_LIST_SUCCESS = 'GET_SENIOR_LIST_ADMIN_SEARCH_LIST_SUCCESS';
export var SET_SENIOR_LIST_ADMIN_LIST_PARAMS = 'SET_SENIOR_LIST_ADMIN_LIST_PARAMS';
export var SET_MEMBER_FACILITY = 'SET_MEMBER_FACILITY';
export var SET_MEMBER_COACHES = 'SET_MEMBER_COACHES';
/**
 * @function getCWMemberRecordsList
 * @description action creator to get CWMemberRecords List
 * @param {string} searchQuery
 * @param {any} lastEvaluatedKey
 * @param {boolean} showLoader if set true will show the ApplicationLoader
 * @param {ShiftTypes[]} shift an array of shifts to filter
 * @param {Roles} role role to filter
 */
export var getCWMemberRecordsList = function (searchQuery, lastEvaluatedKey, showLoader, shift) {
    if (searchQuery === void 0) { searchQuery = ''; }
    if (lastEvaluatedKey === void 0) { lastEvaluatedKey = ''; }
    if (showLoader === void 0) { showLoader = false; }
    if (shift === void 0) { shift = []; }
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, searchQuery, _b, selectedMemberCoach, selectedMemberFacility, accountStatusFilter, isActive, params, response, error_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = getState().common.careAgentList.searchQuery, searchQuery = _a === void 0 ? '' : _a;
                    _b = getState().common.careAgentList, selectedMemberCoach = _b.selectedMemberCoach, selectedMemberFacility = _b.selectedMemberFacility, accountStatusFilter = _b.accountStatusFilter;
                    isActive = null;
                    if (accountStatusFilter === 'Enabled') {
                        isActive = 'true';
                    }
                    else if (accountStatusFilter === 'Disabled') {
                        isActive = 'false';
                    }
                    if (searchQuery !== '' && !(searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.trim())) {
                        return [2 /*return*/, { data: [], lastEvaluatedKey: '' }];
                    }
                    if (showLoader) {
                        dispatch(showApplicationLoader());
                    }
                    dispatch({ type: GET_SENIOR_LIST_ADMIN_LIST });
                    params = {};
                    if (lastEvaluatedKey) {
                        params.last_evaluated_key = lastEvaluatedKey;
                    }
                    if (searchQuery) {
                        params.search_by_name = searchQuery;
                    }
                    if (shift.length) {
                        params.shift = JSON.stringify(shift);
                    }
                    if (isActive) {
                        params.is_active = isActive;
                    }
                    if (selectedMemberFacility && selectedMemberFacility !== 'All Agencies') {
                        params.facility = selectedMemberFacility;
                    }
                    if (selectedMemberCoach && selectedMemberCoach !== 'All Wellness Coaches') {
                        params.coach_name = selectedMemberCoach;
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getCWMemberRecordsService(params)];
                case 2:
                    response = _c.sent();
                    dispatch(hideApplicationLoader());
                    return [2 /*return*/, {
                            data: response.result,
                            lastEvaluatedKey: response.lastEvaluatedKey,
                        }];
                case 3:
                    error_1 = _c.sent();
                    dispatch(showError(error_1));
                    dispatch(hideApplicationLoader());
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
/**
 * @function getCWMemberRecordsListAccounts
 * @description action creator to get CWMemberRecords List
 * @param {ShiftTypes[]} shift an array of shifts to filter
 */
export var getCWMemberRecordsListAccounts = function (accountKey) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var filters, accountStatusFilter, pauseStatusFilter, selectedMemberFacility, selectedMemberCoach, searchQuery, isActive, params, lastEvaluatedKey, selectedFacilities, selectedCoaches, response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(showApplicationLoader());
                    dispatch({ type: GET_ACCOUNT_PAGE_LIST, payload: accountKey });
                    filters = getState().common.accounts[accountKey].queryParams;
                    sessionStorage.setItem("".concat(accountKey, "Filters"), JSON.stringify(filters));
                    accountStatusFilter = filters.accountStatusFilter, pauseStatusFilter = filters.pauseStatusFilter, selectedMemberFacility = filters.selectedMemberFacility, selectedMemberCoach = filters.selectedMemberCoach, searchQuery = filters.searchQuery;
                    isActive = null;
                    if (accountStatusFilter === 'Enabled') {
                        isActive = 'true';
                    }
                    else if (accountStatusFilter === 'Disabled') {
                        isActive = 'false';
                    }
                    if (searchQuery !== '' && !(searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.trim())) {
                        return [2 /*return*/, { data: [], lastEvaluatedKey: '' }];
                    }
                    dispatch({ type: GET_SENIOR_LIST_ADMIN_LIST });
                    params = {};
                    lastEvaluatedKey = getState().common.accounts[accountKey].lastEvaluatedKey;
                    if (lastEvaluatedKey) {
                        params.last_evaluated_key = lastEvaluatedKey;
                    }
                    if (searchQuery) {
                        params.search_by_name = searchQuery;
                    }
                    if (isActive) {
                        params.is_active = isActive;
                    }
                    if (pauseStatusFilter === 'Paused') {
                        params.is_profile_paused = true;
                    }
                    else if (pauseStatusFilter === 'Unpaused') {
                        params.is_profile_paused = false;
                    }
                    selectedFacilities = (Array.isArray(selectedMemberFacility)
                        ? selectedMemberFacility
                        : selectedMemberFacility ? [selectedMemberFacility] : [])
                        .map(function (facility) { return typeof facility === 'string' ? facility : facility === null || facility === void 0 ? void 0 : facility.name; })
                        .filter(function (name) { return name && name !== 'All Agencies'; });
                    if (selectedFacilities.length > 0) {
                        params.facility = selectedFacilities;
                    }
                    selectedCoaches = (Array.isArray(selectedMemberCoach)
                        ? selectedMemberCoach
                        : selectedMemberCoach ? [selectedMemberCoach] : [])
                        .map(function (coach) { return typeof coach === 'string' ? coach : coach === null || coach === void 0 ? void 0 : coach.fullName; })
                        .filter(function (name) { return name && name !== 'All Wellness Coaches'; });
                    if (selectedCoaches.length > 0) {
                        params.coach_name = selectedCoaches;
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getCWMemberRecordsService(params)];
                case 2:
                    response = _a.sent();
                    dispatch(hideApplicationLoader());
                    return [2 /*return*/, {
                            data: response.result,
                            lastEvaluatedKey: response.lastEvaluatedKey,
                        }];
                case 3:
                    error_2 = _a.sent();
                    dispatch(showError(error_2));
                    dispatch(hideApplicationLoader());
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
/**
 * @function getCWMemberRecordsWithoutOvernight
 * @description action creator to get CWMemberRecords List without shift Overnight
 * @param {string} searchQuery
 * @param {any} lastEvaluatedKey
 * @param {boolean} showLoader if set true will show the ApplicationLoader
 */
export var getCWMemberRecordsWithoutOvernight = function (searchQuery, lastEvaluatedKey, showLoader) {
    if (searchQuery === void 0) { searchQuery = ''; }
    if (lastEvaluatedKey === void 0) { lastEvaluatedKey = ''; }
    if (showLoader === void 0) { showLoader = false; }
    return getCWMemberRecordsList(searchQuery, lastEvaluatedKey, showLoader);
};
/**
 * @function getCWMemberRecordsSuccess
 * @description action creator to store cWMemberRecords table data
 * @param tableData
 */
export var getCWMemberRecordsSuccess = function (tableData) { return function (dispatch) {
    var data = tableData.data;
    dispatch({
        type: GET_SENIOR_LIST_ADMIN_LIST_SUCCESS,
        payload: {
            data: data,
        },
    });
}; };
/**
 * @function getCWMemberRecordsSearchListSuccess
 * @description action creator to store cWMemberRecords table data
 * @param tableData
 */
export var getCWMemberRecordsSearchListSuccess = function (tableData) { return function (dispatch) {
    var data = tableData.data, lastEvaluatedKey = tableData.lastEvaluatedKey;
    dispatch({
        type: GET_SENIOR_LIST_ADMIN_SEARCH_LIST_SUCCESS,
        payload: {
            data: data,
            searchLastEvaluatedKey: lastEvaluatedKey,
        },
    });
}; };
/**
 * @function getCWMemberRecordsFail
 * @description action creator to fetch error on api get fail
 * @param error
 */
export var getCWMemberRecordsFail = function (error) { return function (dispatch) {
    dispatch(showError(error));
    dispatch({
        type: GET_SENIOR_LIST_ADMIN_LIST_FAIL,
    });
}; };
/**
 * @function updateCWMemberRecordsPageNumber
 * @description action creator to update the page number of cWMemberRecords table
 * @param {string | number} value
 */
export var updateCWMemberRecordsPageNumber = function (value) { return function (dispatch) {
    dispatch({ type: UPDATE_SENIOR_LIST_ADMIN_LIST_PAGE_NUMBER, payload: value });
}; };
/**
 * @function resetCWMemberRecords
 * @description action creator to reset cWMemberRecords table
 */
export var resetCWMemberRecords = function () { return function (dispatch) {
    dispatch({
        type: RESET_SENIOR_LIST_ADMIN_LIST,
    });
}; };
/**
 * @description search careAgent by name
 * @function searchCWMemberRecordsByName
 * @param {any[]} data
 * @param {string} searchQuery
 * @returns {any[]}
 */
export var searchCWMemberRecordsByName = function (data, searchQuery) {
    if (data === void 0) { data = []; }
    if (searchQuery === void 0) { searchQuery = ''; }
    return data.filter(function (careAgent) {
        var _a;
        var basicInfo = careAgent.name;
        var query = searchQuery.toLowerCase().split(' ');
        var firstName = basicInfo.firstName.toLowerCase() || '';
        var middleName = ((_a = basicInfo.middleName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || '';
        var lastName = basicInfo.lastName.toLowerCase() || '';
        return query.every(function (data) {
            return (firstName.includes(data) ||
                middleName.includes(data) ||
                lastName.includes(data));
        });
    });
};
